import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/system/Box";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import ShareIcon from "@mui/icons-material/Share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import { HOST_URL } from "../../shared/constants";
import { toast } from "react-toastify";
import logo from "./logo.jpg";
import { About } from "./about";
import {Contact} from "./contact";

const MENUS = [
  {
    id: "ABOUT",
    labelKey: "AboutMenu",
    icon: <InfoOutlinedIcon />,
  },
  {
    id: "CONTACT",
    labelKey: "ContactMenu",
    icon: <MessageOutlinedIcon />,
  },
];

export const Drawer = ({ isOpen, onClose = () => {} }) => {
  const { currentLocation } = useSelector((state) => state.map);
  const { t } = useTranslation();
  const [isAboutOpen, setAboutOpen] = useState(false);
  const [isContactOpen, setContactOpen] = useState(false);
  const handleClick = (id) => {
    if (id === "ABOUT") {
      setAboutOpen(true);
    }
    if (id === "CONTACT") {
      setContactOpen(true);
    }
  };

  return (
    <>
      <MuiDrawer open={isOpen} onClose={onClose}>
        <Box
          sx={{
            minWidth: "300px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: "200px",
                height: "200px",
              }}
              src={logo}
            />
          </div>
          <Box>
            <List>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('EDASTitle')} />
                </ListItemButton>
              </ListItem>
            </List>
            <Divider />
            <List>
              {MENUS.map((menu) => (
                <ListItem
                  key={menu.id}
                  disablePadding
                  onClick={() => handleClick(menu.id)}
                >
                  <ListItemButton>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={t(menu.labelKey)} />
                  </ListItemButton>
                </ListItem>
              ))}

              {currentLocation && (
                <ListItem disablePadding>
                  <CopyToClipboard
                    text={`${HOST_URL}/open?lat=${currentLocation?.[1]}&lng=${currentLocation?.[0]}`}
                    onCopy={() =>
                      toast.info("Link copied to clipboard", {
                        position: "bottom-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        closeButton: false,
                      })
                    }
                  >
                    <ListItemButton>
                      <ListItemIcon>
                        <ShareIcon />
                      </ListItemIcon>
                      <ListItemText primary={t('ShareYourLocation')} />
                    </ListItemButton>
                  </CopyToClipboard>
                </ListItem>
              )}
            </List>
            <List style={{ bottom: 0 }} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <ListItemText>{t('GetHelp')}</ListItemText>
                </ListItemIcon>
              </ListItemButton>
            </List>
          </Box>
        </Box>
      </MuiDrawer>
      <About isOpen={isAboutOpen} onClose={() => setAboutOpen(false)} />
      <Contact isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
};
